import styled from 'styled-components'
import { ProvStyleProps } from './interfaces'

export const Main = styled.main`
  overflow-x: hidden;
  overflow-y: scroll;
  margin-bottom: 30px;
  height: 540px;
  h2 {
    margin-bottom: 35px;
    line-height: 1.4;
    margin-bottom: 35px;
    font-size: 20px;
  }
`
export const Title = styled.div<ProvStyleProps>`
  line-height: 1.4;
  margin-bottom: 22px;
  font-size: 20px;
  color: ${({ colors }) => colors.secondary};
  .nonce {
    height: 30px;
  }
  p,
  textarea {
    font-family: 'GT America, regular';
    background: transparent;
    border: none;
    outline: none;
    color: transparent;
    text-shadow: 0 0 0 ${({ colors }) => colors.secondary};
    font-size: 18px;
    margin: auto;
    appearance: none;
    cursor: ${p => (p.copyCursor ? 'copy' : 'auto')};
    width: 100%;
    max-width: 500px;
    resize: none;
    user-select: text !important;
    line-height: 1.4;
    scrollbar-width: none;
    :focus {
      outline-offset: 10px;
      outline: none;
      border: none;
      outline: 0;
    }
    ::selection {
      background: none;
      border: none;
      text-decoration-line: underline;
      :-moz-focus-inner {
        border: none;
        outline: none;
      }
    }
  }
`
